import { ReactNode } from 'react'
import { cn } from '@/lib/utils'

type OdinListEmptyProps = {
  image?: ReactNode
  title: string
  description?: string
  className?: string
}

// Centered empty-state for lists: optional floating illustration + title + hint.
export const OdinListEmpty = ({ image, title, description, className }: OdinListEmptyProps) => {
  return (
    <div className={cn('flex flex-col items-center justify-center grow px-6 py-10 text-center animate-fade-in', className)}>
      {image && <div className="animate-float">{image}</div>}

      <p className="mt-4 text-base font-semibold text-foreground">{title}</p>
      {description && <p className="mt-1 text-sm max-w-[220px] text-muted-foreground">{description}</p>}
    </div>
  )
}
